import { render, staticRenderFns } from "./MoleculeProjectsAndCities.vue?vue&type=template&id=0a9028fe&"
import script from "./MoleculeProjectsAndCities.vue?vue&type=script&lang=js&"
export * from "./MoleculeProjectsAndCities.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeProjectsAndCities.vue?vue&type=style&index=0&id=0a9028fe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsPortfolioAtomTabCity: require('/app/components/atoms/portfolio/AtomTabCity.vue').default})
